import ApolloClient from 'apollo-boost';

const config = require("../config");

export const clientURI = new ApolloClient({
  uri: config.backend.uri + "/graphql",
});


// WEBPACK FOOTER //
// ./src/libraries/clientURI.js